import {ApplicationLocale} from 'src/js/common/types';
import {FetcherUtils} from 'src/js/common/utils/fetcher_utils';
import {I18nConfig, I18nConfigRaw} from 'src/js/model/i18n_config';
import {AppThunk} from 'src/js/store';

import {APP_MESSAGES_ID, CORE_MESSAGES_ID} from './i18n_constants';
import {i18nSlice} from './i18n_slice';

export function changeCurrentLocale(locale: ApplicationLocale, reload: boolean = true): AppThunk {
  return (dispatch) => {
    dispatch(i18nSlice.actions.changeCurrentLocale({locale}));
    FetcherUtils.setCookieValue('locale', locale);

    if (reload) {
      // reload applications to refresh translated labels
      window.location.reload();
    }
  };
}
export function setI18nConfig(config: I18nConfigRaw, reload = false): AppThunk {
  return async (dispatch) => {
    const i18ConfigModel = new I18nConfig(config);
    i18ConfigModel.loadInternationalizationAPILocaleData();
    const newLocale = i18ConfigModel.determineLocale();
    await dispatch(changeCurrentLocale(newLocale, false));
    dispatch(i18nSlice.actions.setConfig({config, reload}));
  };
}

export function loadI18nConfig(reload = false): AppThunk {
  return (dispatch, getState, {config}) => dispatch(setI18nConfig(config.common.i18n, reload));
}

export function loadLocaleMessages(locale: ApplicationLocale): AppThunk {
  return (dispatch, getState, {config}) => {
    dispatch(
      i18nSlice.actions.addLocaleMessages({
        id: CORE_MESSAGES_ID,
        messages: config.locales.core[locale],
        locale,
      })
    );
    dispatch(
      i18nSlice.actions.addLocaleMessages({
        id: APP_MESSAGES_ID,
        messages: config.locales.application[locale],
        locale,
      })
    );
  };
}
